<script setup>
import { onMounted } from "vue";

import AppGuestShell from "@/components/AppGuestShell";
import AppRequestForm from "@/components/PasswordReset/AppRequestForm";

import { store } from "@/store";

onMounted(async () => {
  try {
    store.APP_LOADING = true;
  } finally {
    store.APP_LOADING = false;
  }
});
</script>

<template lang="pug">
AppGuestShell
  AppRequestForm
</template>
